import axios from "axios"

export default axios.create({
    baseURL: "/guru-cms-api-web/web/api",
    headers: { 'Cache-Control': 'no-cache', 'Content-type': 'application/json; charset=UTF-8' }
});